import { render, staticRenderFns } from "./ResearchArticleSave.vue?vue&type=template&id=2bcfb285&"
import script from "./ResearchArticleSave.vue?vue&type=script&lang=js&"
export * from "./ResearchArticleSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports